<template>
    <Head title="Admin"/>

    <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Admin
    </h1>
</template>

<script>
    import Layout from '@/Layouts/Authenticated.vue';
    import {Head} from "@inertiajs/vue3";

    export default {
        layout: Layout,
        components: {
            Head
        }
    }

</script>
